import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { Section, Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import { SeoProductsItem } from "./SeoProductsItem";
import "./style.scss";

export const SeoProducts: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  return (
    <div className="SeoProducts">
      <div className="SeoProducts-title">{section.title}</div>
      {tiles.map((tile) => (
        <SeoProductsItem key={tile.slug} tile={tile} />
      ))}
      <div className="SeoProducts-cta-wrapper">
        {section.cta.map((cta) => {
          return (
            <ButtonSmily
              href={getLink(cta.navigationLink, localeSlug)}
              key={cta.text}
              size="m"
              type="secondary"
            >
              <h2>{cta.text}</h2>
            </ButtonSmily>
          );
        })}
      </div>
    </div>
  );
};
